import { AppRoute } from '@app/core/routing/AppRoute';
import { LoggerStatusPage } from '@app/modules/logger/screens/status/LoggerStatusPage';
import { StreamQualityReportPage } from '@app/modules/logger/screens/reports/stream-quality/StreamQualityReportPage';
import { Redirect, Switch } from 'react-router-dom';
import { LoggerStreamAdapterPage } from './LoggerStreamAdapterPage';

export default function LoggerRoutes() {
  return (
    <Switch>
      <AppRoute path="/logger/status" component={LoggerStatusPage} />
      <AppRoute path="/logger/s/:slug" component={LoggerStreamAdapterPage} />
      <Redirect exact from="/logger/reports" to="/logger/reports/stream-quality" />
      <AppRoute path="/logger/reports/stream-quality" component={StreamQualityReportPage} />

      {/* old routes compatibility */}
      <Redirect exact path="/logger/station/:slug" to="/logger/s/:slug" />
      <Redirect exact from="/logger/youtube-broadcasts" to="/youtube-broadcasts" />
      <Redirect from="/logger/youtube-broadcasts/s/:slug" to="/youtube-broadcasts/s/:slug" />

      {/* catch all */}
      <Redirect to="/logger/status" />
    </Switch>
  );
}
